<template>
  <div></div>
</template>

<script>
  import runtimeConfig from '@/common/runtime-config';

  import {
    buildAuthorizationUrl,
    generateCodeChallenge,
    generateCodeVerifier,
    generateRandomString,
    savePkceData,
  } from '@/modules/auth/utils/pkce';

  export default {
    name: 'Login',
    async created() {
      const returnUrl = this.$route.query.returnUrl;
      if (returnUrl) sessionStorage.setItem('oidc_return_url', returnUrl);
      else sessionStorage.removeItem('oidc_return_url');

      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      const state = generateRandomString();
      const nonce = generateRandomString();

      savePkceData({ codeVerifier, state });

      const authUrl = buildAuthorizationUrl({
        authorizationEndpoint: runtimeConfig.oidc.authorizationEndpoint,
        clientId: runtimeConfig.oidc.clientId,
        redirectUri: runtimeConfig.oidc.redirectUri,
        scope: runtimeConfig.oidc.scope,
        codeChallenge,
        state,
        nonce,
      });
      window.location.href = authUrl;
    },
  };
</script>
